module.exports = __webpack_public_path__ + "img/f6f269ca6f9e065e27836603ffc5adfe.png";